export default __webpack_public_path__ + "static/media/FTNLogo.b536a93c.png";